import React from 'react';

interface ARViewProps {
    filterPanel: React.ReactNode;
    table: React.ReactNode;
    embedded?: boolean;
}

const ARView: React.FC<ARViewProps> = ({ filterPanel, table, embedded = false }) => (
    <>
        {filterPanel && (
            <div className={embedded ? 'mb-3' : 'bg-white rounded-lg mb-3'}>
                {filterPanel}
            </div>
        )}

        <div className="flex-1 min-h-0 overflow-hidden bg-white rounded-lg shadow-sm border border-gray-200">
            <div className="flex h-full min-h-0 flex-col overflow-hidden">
                {table}
            </div>
        </div>
    </>
);

export default ARView;
